import $api from './instance';

export * from './auth';
export * from './properties';
export * from './units';
export * from './lease';
export * from './invite';
export * from './tenants';
export * from './managers';
export * from './users';
export * from './chats';
export * from './payments';
export * from './statistics';
export * from './files';
export * from './dictionaries';
export * from './developer';
export { getUIOptionsRequest } from './options'; // Explicitly export getUIOptionsRequest

export default $api;
